<app-pdf-sign-viewer *ngIf="envelope" [envelope]="envelope" (afterSignature)="sigsRemaining($event)"
  (afterLoadComplete)="app.HideSpinner();">
</app-pdf-sign-viewer>